export default __webpack_public_path__ + "static/media/Connectivity-HD.82f934ab.jpg";